import { render, staticRenderFns } from "./newFiltercomp.vue?vue&type=template&id=20ebc95a"
import script from "./newFiltercomp.vue?vue&type=script&lang=js"
export * from "./newFiltercomp.vue?vue&type=script&lang=js"
import style0 from "./newFiltercomp.vue?vue&type=style&index=0&id=20ebc95a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports